/**
 * Общие утилиты для работы с коллекторами
 * Используется во всех редакторах коллекторов
 */

import { DEFAULT_PIPE_COMBOS } from '../pipeCatalog';
import fittingsData from '../fittingsData';
import { determineThickness, getActualCoating, getAvailableThicknesses } from './pipeThicknessUtils';

// ============================================================================
// КОНСТАНТЫ
// ============================================================================

/**
 * Маппинг DN (условный проход) на диаметр трубы
 */
export const DN_TO_PIPE_DIAMETER = {
  '15': 21.3,
  '20': 26.9,
  '25': 33.7,
  '32': 42.4,
  '40': 48.3,
  '50': 60.3,
  '65': 76.1,
  '80': 88.9,
  '100': 114.3,
  '125': 139.7,
  '150': 168.3,
  '200': 219.1,
  '250': 273,
  '300': 323.9,
  '350': 355.6,
  '500': 609.6,
};

/**
 * Маппинг размеров накидных гаек на диаметр трубы
 */
export const NAK_GAIKA_TO_PIPE_DIAMETER = {
  '1': 21.3,
  '1_1.4': 32,
  '1_1.2': 32,
  '2': 42.4,
};

/**
 * Маппинг размеров шайб с наружной резьбой на диаметр трубы
 */
export const SHAIBA_NAR_REZBA_TO_PIPE_DIAMETER = {
  '1': 26.9,
  '1_1.4': 32,
  '1_1.2': 32,
  '2': 42.4,
};

/**
 * Категории фитингов для контуров
 */
export const CIRCUIT_FITTING_CATEGORIES = [
  { id: 'Ниппели', label: 'Ниппели' },
  { id: 'Муфты', label: 'Муфты' },
  { id: 'Фланцы', label: 'Фланцы' },
  { id: 'Накидные гайки', label: 'Накидные гайки' },
  { id: 'Шайбы с наружной резьбой', label: 'Шайбы с нар. резьбой' },
];

/**
 * Лицевые и центральные фитинги: те же категории, что у контура.
 */
export const CENTER_FITTING_CATEGORIES = CIRCUIT_FITTING_CATEGORIES;

/**
 * Таблица глубины вставки труб коллектора в гидроразделитель (в мм)
 * Ключ: "диаметр_гидроразделителя→диаметр_коллектора"
 * Значение: глубина вставки в миллиметрах
 */
export const INSERTION_DEPTH_TABLE = {
  '76.1→42.4': 20,
  '76.1→48.3': 20,
  '88.9→42.4': 20,
  '88.9→48.3': 20,
  '88.9→60.3': 20,
  '101.6→42.4': 20,
  '101.6→48.3': 20,
  '101.6→60.3': 20,
  '114.3→42.4': 20,
  '114.3→48.3': 20,
  '114.3→60.3': 20,
  '114.3→76.1': 25,
  '129→42.4': 20,
  '129→48.3': 20,
  '129→60.3': 20,
  '129→76.1': 25,
  '129→88.9': 30,
  '139.7→42.4': 20,
  '139.7→48.3': 20,
  '139.7→60.3': 20,
  '139.7→76.1': 25,
  '139.7→88.9': 25,
  '159→42.4': 20,
  '159→48.3': 20,
  '159→60.3': 20,
  '159→76.1': 20,
  '159→88.9': 25,
  '159→101.6': 30,
  '159→114.3': 35,
  '168.3→42.4': 20,
  '168.3→48.3': 20,
  '168.3→60.3': 20,
  '168.3→76.1': 20,
  '168.3→88.9': 25,
  '168.3→101.6': 30,
  '168.3→114.3': 35,
  '219.1→42.4': 20,
  '219.1→48.3': 20,
  '219.1→60.3': 20,
  '219.1→76.1': 20,
  '219.1→88.9': 20,
  '219.1→101.6': 25,
  '219.1→114.3': 30,
  '219.1→129': 30,
  '219.1→139.7': 35,
  '219.1→159': 45,
  '273→42.4': 20,
  '273→48.3': 20,
  '273→60.3': 20,
  '273→76.1': 20,
  '273→88.9': 20,
  '273→101.6': 20,
  '273→114.3': 25,
  '273→129': 30,
  '273→139.7': 30,
  '273→159': 35,
  '273→168.3': 40,
  '323.9→42.4': 20,
  '323.9→48.3': 20,
  '323.9→60.3': 20,
  '323.9→76.1': 20,
  '323.9→88.9': 20,
  '323.9→101.6': 20,
  '323.9→114.3': 20,
  '323.9→129': 25,
  '323.9→139.7': 30,
  '323.9→159': 30,
  '323.9→168.3': 35,
  '323.9→219.1': 55,
  '355.6→42.4': 20,
  '355.6→48.3': 20,
  '355.6→60.3': 20,
  '355.6→76.1': 20,
  '355.6→88.9': 20,
  '355.6→101.6': 20,
  '355.6→114.3': 20,
  '355.6→129': 25,
  '355.6→139.7': 25,
  '355.6→159': 30,
  '355.6→168.3': 35,
  '355.6→219.1': 50,
  '406.4→42.4': 20,
  '406.4→48.3': 20,
  '406.4→60.3': 20,
  '406.4→76.1': 20,
  '406.4→88.9': 20,
  '406.4→101.6': 20,
  '406.4→114.3': 20,
  '406.4→129': 20,
  '406.4→139.7': 25,
  '406.4→159': 30,
  '406.4→168.3': 30,
  '406.4→219.1': 45,
  '406.4→273': 65,
  '508→42.4': 20,
  '508→48.3': 20,
  '508→60.3': 20,
  '508→76.1': 20,
  '508→88.9': 20,
  '508→101.6': 20,
  '508→114.3': 20,
  '508→129': 20,
  '508→139.7': 20,
  '508→159': 25,
  '508→168.3': 25,
  '508→219.1': 35,
  '508→273': 50,
  '508→323.9': 70,
  '508→355.6': 85,
  '609.6→42.4': 20,
  '609.6→48.3': 20,
  '609.6→60.3': 20,
  '609.6→76.1': 20,
  '609.6→88.9': 20,
  '609.6→101.6': 20,
  '609.6→114.3': 20,
  '609.6→129': 20,
  '609.6→139.7': 20,
  '609.6→159': 20,
  '609.6→168.3': 25,
  '609.6→219.1': 30,
  '609.6→273': 45,
  '609.6→323.9': 60,
  '609.6→355.6': 70,
  '609.6→406.4': 90,
};

// ============================================================================
// ФУНКЦИИ ДЛЯ РАБОТЫ С ДИАМЕТРАМИ
// ============================================================================

/**
 * Получает список доступных диаметров труб из каталога
 * @param {Object} options - опции фильтрации
 * @param {number} options.minDiameter - минимальный диаметр (по умолчанию 38)
 * @param {number[]} options.excludeDiameters - исключаемые диаметры (по умолчанию [54, 306])
 * @returns {Array<{value: number, label: string}>}
 */
export const getAvailableDiameters = (options = {}) => {
  const { minDiameter = 38, excludeDiameters = [54, 306] } = options;
  
  const diameters = new Set();
  Object.keys(DEFAULT_PIPE_COMBOS).forEach(key => {
    const [diameter] = key.split('|');
    diameters.add(parseFloat(diameter));
  });
  
  return Array.from(diameters)
    .filter(d => d > minDiameter && !excludeDiameters.includes(d))
    .sort((a, b) => a - b)
    .map(d => ({
      value: d,
      label: `⌀${d}`,
    }));
};

/**
 * Нижняя граница мощности в форме характеристик (как у гидроразделителя).
 */
export const THERMAL_POWER_INPUT_MIN_KW = 40;

/**
 * Тот же набор ⌀×s, что в CharacteristicsCalculator (макс. корпус для лимита мощности круга).
 */
const HYDRAULIC_SEPARATOR_STYLE_MAX_POWER_PIPE_ROWS = [
  { outerDiameter: 42.4, wallThickness: 2 },
  { outerDiameter: 42.4, wallThickness: 3 },
  { outerDiameter: 48.3, wallThickness: 2 },
  { outerDiameter: 48.3, wallThickness: 3 },
  { outerDiameter: 60.3, wallThickness: 2 },
  { outerDiameter: 60.3, wallThickness: 3 },
  { outerDiameter: 76.1, wallThickness: 2 },
  { outerDiameter: 76.1, wallThickness: 3 },
  { outerDiameter: 88.9, wallThickness: 2 },
  { outerDiameter: 88.9, wallThickness: 3 },
  { outerDiameter: 101.6, wallThickness: 2 },
  { outerDiameter: 114.3, wallThickness: 2 },
  { outerDiameter: 114.3, wallThickness: 3 },
  { outerDiameter: 129, wallThickness: 2 },
  { outerDiameter: 129, wallThickness: 3 },
  { outerDiameter: 139.7, wallThickness: 2 },
  { outerDiameter: 139.7, wallThickness: 3 },
  { outerDiameter: 159, wallThickness: 2 },
  { outerDiameter: 159, wallThickness: 3 },
  { outerDiameter: 168.3, wallThickness: 3 },
  { outerDiameter: 219.1, wallThickness: 3 },
  { outerDiameter: 273, wallThickness: 3 },
  { outerDiameter: 323.9, wallThickness: 3 },
  { outerDiameter: 355.6, wallThickness: 3 },
  { outerDiameter: 406.4, wallThickness: 3 },
  { outerDiameter: 508, wallThickness: 3 },
  { outerDiameter: 609.6, wallThickness: 3 },
];

/** Ключ профиля квадрата для верхнего лимита мощности в калькуляторе распределителя (макс. сторона каталога). */
export const COLLECTOR_CHARACTERISTICS_MAX_SQUARE_PROFILE_VALUE = '150x150';

const WATER_DENSITY_KG_M3 = 1000;
const WATER_SPECIFIC_HEAT_J_KG_K = 4190;

/** Как в CollectorCharacteristicsCalculator: макс. профиль квадрата и стенка для стороны 150 мм. */
const DISTRIBUTION_COLLECTOR_SQUARE_MAX_POWER_SIDE_MM = 150;
const DISTRIBUTION_COLLECTOR_SQUARE_MAX_POWER_WALL_MM = 3;
/** Верхняя граница допустимой скорости в корпусе коллектора (м/с). */
const DISTRIBUTION_COLLECTOR_MAX_VELOCITY_MS = 0.8;

/**
 * Верхняя мощность (кВт) для режима «Расчёт по характеристикам» распределительного коллектора (вода):
 * квадрат — макс. профиль 150×150 мм (внутреннее ребро как в calculateVelocitySquare), скорость до 0.8 м/с;
 * круг — как у гидроразделителя: макс. ⌀ из каталога и 0.25 м/с. Зависит от ΔT.
 */
export function getMaxThermalPowerKwCollectorCharacteristics(shape, deltaTemp) {
  const dt = Number(deltaTemp);
  if (!Number.isFinite(dt) || dt <= 0) {
    return 0;
  }
  if (shape === 'square') {
    const innerMm =
      DISTRIBUTION_COLLECTOR_SQUARE_MAX_POWER_SIDE_MM -
      2 * DISTRIBUTION_COLLECTOR_SQUARE_MAX_POWER_WALL_MM;
    const areaM2 = (innerMm / 1000) * (innerMm / 1000);
    const maxFlowRateM3s = areaM2 * DISTRIBUTION_COLLECTOR_MAX_VELOCITY_MS;
    const maxFlowRateM3h = maxFlowRateM3s * 3600;
    const powerKw =
      ((maxFlowRateM3h / 3600) * WATER_DENSITY_KG_M3 * WATER_SPECIFIC_HEAT_J_KG_K * dt) / 1000;
    return Math.floor(powerKw);
  }

  const maxD = HYDRAULIC_SEPARATOR_STYLE_MAX_POWER_PIPE_ROWS[HYDRAULIC_SEPARATOR_STYLE_MAX_POWER_PIPE_ROWS.length - 1];
  const innerDiameter = maxD.outerDiameter - 2 * maxD.wallThickness;
  const area = Math.PI * Math.pow(innerDiameter / 1000 / 2, 2);
  const maxVelocity = 0.25;
  const maxFlowRateM3s = area * maxVelocity;
  const maxFlowRateM3h = maxFlowRateM3s * 3600;
  const powerKw =
    ((maxFlowRateM3h / 3600) * WATER_DENSITY_KG_M3 * WATER_SPECIFIC_HEAT_J_KG_K * dt) / 1000;
  return Math.floor(powerKw);
}

/**
 * Верхняя мощность (кВт) по корпусу квадратной гидрострелки каталога: профиль 150×150 мм, стенка 3 мм, скорость 0,25 м/с
 * (как верхняя граница диапазона 0,09–0,25 м/с в комбинированном узле). Для подсказки «до … кВт» при квадратном сечении.
 */
export function getMaxThermalPowerKwSeparatorSquareCorpus(deltaTemp) {
  const dt = Number(deltaTemp);
  if (!Number.isFinite(dt) || dt <= 0) return 0;
  const sideMm = 150;
  const wallMm = 3;
  const innerMm = sideMm - 2 * wallMm;
  const areaM2 = (innerMm / 1000) * (innerMm / 1000);
  const maxFlowRateM3s = areaM2 * 0.25;
  const maxFlowRateM3h = maxFlowRateM3s * 3600;
  const powerKw =
    ((maxFlowRateM3h / 3600) * WATER_DENSITY_KG_M3 * WATER_SPECIFIC_HEAT_J_KG_K * dt) / 1000;
  return Math.floor(powerKw);
}

/**
 * Получает глубину вставки трубы коллектора в гидроразделитель
 * @param {number} separatorDiameter - диаметр трубы гидроразделителя
 * @param {number} collectorDiameter - диаметр трубы коллектора
 * @returns {number} - глубина вставки в миллиметрах (0 если комбинация не найдена)
 */
export const getInsertionDepth = (separatorDiameter, collectorDiameter) => {
  const main = Number(separatorDiameter);
  const branch = Number(collectorDiameter);
  const key = `${main}→${branch}`;
  const direct = INSERTION_DEPTH_TABLE[key];
  if (direct != null) {
    return direct;
  }
  // Патрубок Ду25 (⌀33,7): та же глубина врезки в гребёнку, что у фланцевого Ду32 (⌀42,4)
  if (Math.abs(branch - 33.7) < 0.01) {
    const dn32Key = `${main}→42.4`;
    const fromDn32 = INSERTION_DEPTH_TABLE[dn32Key];
    if (fromDn32 != null) {
      return fromDn32;
    }
  }
  return 0;
};

/**
 * Макс. наружный ⌀ гребёнки для круглой гидрострелки (как в CollectorWithSeparatorEditor), если пары нет в INSERTION_DEPTH_TABLE.
 */
const SEPARATOR_MAIN_TO_MAX_COLLECTOR_PIPE_OD = {
  76.1: 48.3,
  88.9: 60.3,
  101.6: 60.3,
  114.3: 76.1,
  129: 88.9,
  139.7: 88.9,
  159: 114.3,
  168.3: 114.3,
  219.1: 159,
  273: 168.3,
  323.9: 219.1,
  355.6: 219.1,
  406.4: 273,
  508: 355.6,
  609.6: 406.4,
};

/**
 * Круг: гребёнка совместима с корпусом гидрострелки, если есть глубина вставки в каталоге
 * или ⌀ гребёнки не уже корпуса и не превышает максимум по правилам узла (как в редакторе).
 */
export function isRoundCollectorPipeCompatibleWithSeparator(separatorOuterMm, collectorOuterMm) {
  if (separatorOuterMm == null || collectorOuterMm == null) return false;
  if (!Number.isFinite(separatorOuterMm) || !Number.isFinite(collectorOuterMm)) return false;
  if (collectorOuterMm >= separatorOuterMm) return false;
  if (getInsertionDepth(separatorOuterMm, collectorOuterMm) > 0) return true;
  const maxCol = SEPARATOR_MAIN_TO_MAX_COLLECTOR_PIPE_OD[separatorOuterMm];
  const cap = maxCol != null ? maxCol : 406.4;
  return collectorOuterMm <= cap;
}

/**
 * Квадрат: профиль гребёнки не шире профиля гидрострелки (как в CollectorWithSeparatorEditor).
 */
export function isSquareCollectorProfileCompatibleWithSeparator(separatorProfile, collectorProfile) {
  const side = (p) => {
    const parts = String(p).split('x');
    if (parts.length !== 2) return 0;
    return Math.min(Number(parts[0]), Number(parts[1]));
  };
  const sSep = side(separatorProfile);
  const sCol = side(collectorProfile);
  if (sSep <= 0 || sCol <= 0) return false;
  return sCol <= sSep;
}

// ============================================================================
// ФУНКЦИИ ДЛЯ ИЗВЛЕЧЕНИЯ ДАННЫХ ИЗ КЛЮЧЕЙ ФИТИНГОВ
// ============================================================================

/**
 * Извлекает DN из ключа фланца
 * @param {string} flangeKey - ключ фланца (например, "Flanec_galv_50")
 * @returns {string|null} - DN или null
 */
export const extractDnFromFlangeKey = (flangeKey) => {
  if (!flangeKey || !flangeKey.startsWith('Flanec_')) return null;
  // Извлекаем DN из ключа формата "Flanec_{DN}_{тип}" или "Flanec_{DN}"
  const match = flangeKey.match(/Flanec_(\d+)/);
  return match ? match[1] : null;
};

/**
 * Извлекает размер из ключа накидной гайки
 * @param {string} nakGaikaKey - ключ накидной гайки (например, "Nak_Gaika_1")
 * @returns {string|null} - размер или null
 */
export const extractSizeFromNakGaikaKey = (nakGaikaKey) => {
  if (!nakGaikaKey || !nakGaikaKey.startsWith('Nak_Gaika_')) return null;
  const match = nakGaikaKey.match(/Nak_Gaika_(.+)/);
  return match ? match[1] : null;
};

/**
 * Извлекает размер из ключа шайбы с наружной резьбой
 * @param {string} key - ключ шайбы
 * @returns {string|null} - размер или null
 */
export const extractSizeFromShaibaNarRezba = (key) => {
  if (!key || !key.startsWith('Shaib_Nar_Rezba_')) return null;
  const match = key.match(/Shaib_Nar_Rezba_(.+)/);
  return match ? match[1] : null;
};

// ============================================================================
// ФУНКЦИИ ДЛЯ ПОЛУЧЕНИЯ ДИАМЕТРОВ ТРУБ ПО ФИТИНГАМ
// ============================================================================

/**
 * Получает диаметр трубы по DN
 * @param {string} dn - условный проход
 * @returns {number|null} - диаметр трубы или null
 */
export const getPipeDiameterForDn = (dn) => {
  return DN_TO_PIPE_DIAMETER[dn] || null;
};

/**
 * Получает диаметр трубы по размеру накидной гайки
 * @param {string} size - размер (например, "1", "1_1.4")
 * @returns {number|null} - диаметр трубы или null
 */
export const getPipeDiameterForNakGaika = (size) => {
  return NAK_GAIKA_TO_PIPE_DIAMETER[size] || null;
};

/**
 * Получает диаметр трубы по размеру шайбы с наружной резьбой
 * @param {string} size - размер (например, "1", "1_1.4")
 * @returns {number|null} - диаметр трубы или null
 */
export const getPipeDiameterForShaibaNarRezba = (size) => {
  return SHAIBA_NAR_REZBA_TO_PIPE_DIAMETER[size] || null;
};

/** Диаметр трубы, к которой крепится фитинг. У фланца это не наружный диаметр. */
export const getFittingConnectionDiameter = (fittingId) => {
  const info = fittingsData[fittingId];
  if (!info) return null;
  if (String(fittingId).startsWith('Flanec_')) {
    return getPipeDiameterForDn(extractDnFromFlangeKey(fittingId)) || info.diameter;
  }
  if (String(fittingId).startsWith('Nak_Gaika_')) {
    return getPipeDiameterForNakGaika(extractSizeFromNakGaikaKey(fittingId)) || info.diameter;
  }
  if (String(fittingId).startsWith('Shaib_Nar_Rezba_')) {
    return getPipeDiameterForShaibaNarRezba(extractSizeFromShaibaNarRezba(fittingId)) || info.diameter;
  }
  return info.diameter;
};

// ============================================================================
// ФУНКЦИИ ДЛЯ ПОИСКА ФИТИНГОВ
// ============================================================================

/**
 * Получает ключ шайбы (бортшайбы или шайбы с нар. резьбой) для фитинга
 * @param {string} fittingKey - ключ фитинга
 * @returns {string|null} - ключ шайбы или null
 */
export const getShaibaKeyForFitting = (fittingKey) => {
  if (!fittingKey) return null;
  
  // Для фланцев - бортшайба
  if (fittingKey.startsWith('Flanec_')) {
    const dn = extractDnFromFlangeKey(fittingKey);
    if (dn) return `Bortshaiba_${dn}`;
  }
  
  // Для накидных гаек - шайба накидной гайки
  if (fittingKey.startsWith('Nak_Gaika_')) {
    const size = extractSizeFromNakGaikaKey(fittingKey);
    if (size) return `Shaib_Gaika_${size}`;
  }
  
  return null;
};

/**
 * Переходы есть в каталоге фитингов, но автоконструктор их не предлагает:
 * на торце вместо них ставится эллиптическая заглушка.
 * 114.3→88.9 (фланец Ду80, ниппель 3" и аналогичные торцы на трубе 114.3).
 */
export const AUTO_CONSTRUCTOR_EXCLUDED_REDUCER_KEYS = new Set([
  'Perehod_Konc_114.3х88.9',
]);

export const isAutoConstructorReducerAllowed = (key) =>
  !AUTO_CONSTRUCTOR_EXCLUDED_REDUCER_KEYS.has(key);

/**
 * Находит концентрический переход по диаметрам
 * @param {number} fromDiameter - диаметр "от"
 * @param {number} toDiameter - диаметр "до"
 * @returns {Object|null} - объект с данными перехода или null
 */
export const findConcentricReducer = (fromDiameter, toDiameter) => {
  if (!fromDiameter || !toDiameter) return null;
  
  // Используем кириллическую "х" (как в данных)
  const key = `Perehod_Konc_${fromDiameter}х${toDiameter}`;
  if (!isAutoConstructorReducerAllowed(key)) return null;
  const data = fittingsData[key];
  
  if (data) {
    return {
      key: key,
      id: key,
      label: data.displayName,
      diameter: data.diameter,
      length: data.length,
    };
  }
  
  return null;
};

/**
 * Получает все концентрические переходы
 * @returns {Array<Object>} - массив переходов
 */
export const getConcentricReducers = () => {
  return Object.entries(fittingsData)
    .filter(([key, data]) => data.category === 'Переходы концентрические' && isAutoConstructorReducerAllowed(key))
    .map(([key, data]) => ({
      id: key,
      label: data.displayName.replace('Переход концентрический ', ''),
      diameter: data.diameter,
      length: data.length,
    }));
};

/**
 * Находит эллиптическую заглушку по диаметру
 * @param {number} diameter - диаметр
 * @returns {Object|null} - объект с данными заглушки или null
 */
export const findEllipticalCap = (diameter) => {
  if (!diameter) return null;
  
  const key = `Zaglushka_EL_${diameter}`;
  const data = fittingsData[key];
  
  if (data) {
    return {
      id: key,
      label: data.displayName,
      diameter: data.diameter,
      length: data.length,
    };
  }
  
  return null;
};

/**
 * Находит прямую заглушку по диаметру
 * @param {number} diameter - диаметр
 * @returns {Object|null} - объект с данными заглушки или null
 */
export const findStraightCap = (diameter) => {
  if (!diameter) return null;
  
  const key = `Zaglushka_PR_${diameter}`;
  const data = fittingsData[key];
  
  if (data) {
    return {
      id: key,
      label: data.displayName,
      diameter: data.diameter,
      length: data.length,
    };
  }
  
  return null;
};

/**
 * Получает фитинги по категории с опциональной фильтрацией по совместимости
 * @param {string} category - категория фитинга
 * @param {number|null} mainPipeDiameter - диаметр основной трубы для проверки совместимости
 * @param {Function|null} compatibilityCheck - функция проверки совместимости
 * @returns {Array<Object>} - массив фитингов
 */
export const getFittingsByCategory = (category, mainPipeDiameter = null, compatibilityCheck = null) => {
  return Object.entries(fittingsData)
    .filter(([key, data]) => {
      if (data.category !== category) return false;
      if (mainPipeDiameter && compatibilityCheck) {
        return compatibilityCheck(key, mainPipeDiameter);
      }
      return true;
    })
    .map(([key, data]) => ({
      id: key,
      label: data.displayName,
      diameter: data.diameter,
      length: data.length,
    }));
};

/** Крупнейший по каталожному diameter фитинг категории, для которого isCompatible(id). Как последний элемент при поджиме в редакторе. */
export const pickLargestCompatibleFittingIdInCategory = (category, isCompatible) => {
  const rows = Object.entries(fittingsData)
    .filter(([, d]) => d.category === category)
    .map(([id, d]) => ({
      id,
      diameter: Number(d.diameter) || 0,
    }))
    .filter(({ id }) => isCompatible(id))
    .sort((a, b) => a.diameter - b.diameter || String(a.id).localeCompare(String(b.id)));
  return rows.length ? rows[rows.length - 1].id : null;
};

// ============================================================================
// ФУНКЦИИ ДЛЯ ПРОВЕРКИ СОВМЕСТИМОСТИ
// ============================================================================

/**
 * Проверяет совместимость фитинга с основной трубой коллектора
 * @param {string} fittingId - ID фитинга
 * @param {number} mainPipeDiameter - диаметр основной трубы
 * @returns {boolean} - true если совместим
 */
export const isFittingCompatibleWithMainPipe = (fittingId, mainPipeDiameter) => {
  if (!fittingId || !mainPipeDiameter) return false;
  
  const fittingInfo = fittingsData[fittingId];
  if (!fittingInfo) return false;
  
  const category = fittingInfo.category;
  
  // Для ниппелей, муфт, накидных гаек и шайб - диаметр фитинга должен быть <= диаметра трубы
  if (category === 'Ниппели' || category === 'Муфты' || category === 'Накидные гайки' || category === 'Шайбы с наружной резьбой') {
    return fittingInfo.diameter <= mainPipeDiameter;
  }
  
  // Для фланцев - извлекаем DN и проверяем соответствие диаметру трубы
  if (category === 'Фланцы') {
    const dn = extractDnFromFlangeKey(fittingId);
    if (!dn) return false;
    const pipeDiameter = getPipeDiameterForDn(dn);
    return pipeDiameter !== null && pipeDiameter <= mainPipeDiameter;
  }
  
  return false;
};

/**
 * Торцевое подключение (источник): совместимость с ⌀ гребёнки.
 *
 * Ниппели/фланцы — не шире приварной трубы ряда. Муфты — по белым спискам для ⌀42.4 и ⌀48.3
 * (согласовано с floorCollectorFittingCompatibility). Если ряд совпадает с ⌀ трубы, на торце
 * без заглушки и без перехода — см. getCapRequirementForFitting (fitsFlush).
 */
export const isEndFittingCompatibleWithMainPipe = (fittingId, mainPipeDiameter) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;

  const category = fittingData.category;

  // Ниппели: не могут быть больше диаметра гребенки
  if (category === 'Ниппели') {
    const nippelDiameter = fittingData.diameter;
    if (nippelDiameter > mainPipeDiameter) {
      return false;
    }
  }

  // Фланцы: не могут быть больше диаметра гребенки
  if (category === 'Фланцы') {
    // Извлекаем Ду из ключа фланца
    const dn = extractDnFromFlangeKey(fittingId);
    if (dn) {
      const flangePipeDiameter = DN_TO_PIPE_DIAMETER[dn];
      if (flangePipeDiameter && flangePipeDiameter > mainPipeDiameter) {
        return false;
      }
    }
  }

  // Муфты: специальные ограничения
  if (category === 'Муфты') {
    if (mainPipeDiameter === 42.4) {
      // До 1¼″; Mufta_1 / Mufta_1_1.4 на торце ⌀42.4 — впритык (getCapRequirementForFitting)
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4'];
      return allowedMuftas.includes(fittingId);
    } else if (mainPipeDiameter === 48.3) {
      // До 1½″; Mufta_1_1.4 / Mufta_1_1.2 на торце ⌀48.3 — впритык (getCapRequirementForFitting)
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4', 'Mufta_1_1.2'];
      return allowedMuftas.includes(fittingId);
    }
    // Для остальных диаметров: без ограничений
  }

  return true;
};

/**
 * Контуры распределительного коллектора — круглая гребёнка (те же правила, что в CollectorCharacteristicsCalculator).
 * Для торцевых подключений используйте isEndFittingCompatibleWithMainPipe.
 */
export const isDistributionCircuitFittingCompatibleWithRoundPipe = (fittingId, mainPipeDiameter) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;
  const category = fittingData.category;

  if (mainPipeDiameter === 42.4) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2'].includes(fittingId);
    if (category === 'Муфты') return ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2'].includes(fittingId);
    if (category === 'Фланцы') return false;
    if (category === 'Накидные гайки') return !['Nak_Gaika_1_1.4', 'Nak_Gaika_1_1.2', 'Nak_Gaika_2'].includes(fittingId);
    if (category === 'Шайбы с наружной резьбой') return false;
  }
  if (mainPipeDiameter === 48.3) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4'].includes(fittingId);
    if (category === 'Муфты') return ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2'].includes(fittingId);
    if (category === 'Фланцы') return false;
    if (category === 'Накидные гайки') return !['Nak_Gaika_1_1.4', 'Nak_Gaika_1_1.2', 'Nak_Gaika_2'].includes(fittingId);
    if (category === 'Шайбы с наружной резьбой') return !['Shaib_Nar_Rezba_1_1.4', 'Shaib_Nar_Rezba_1_1.2', 'Shaib_Nar_Rezba_2'].includes(fittingId);
  }
  if (mainPipeDiameter === 60.3) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1'].includes(fittingId);
    if (category === 'Муфты') return ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1'].includes(fittingId);
    if (category === 'Фланцы') return fittingId.startsWith('Flanec_25_');
    if (category === 'Накидные гайки') return !['Nak_Gaika_2'].includes(fittingId);
    if (category === 'Шайбы с наружной резьбой') return !['Shaib_Nar_Rezba_2'].includes(fittingId);
  }
  if (mainPipeDiameter === 76.1) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4'].includes(fittingId);
    if (category === 'Муфты') return ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1'].includes(fittingId);
    if (category === 'Фланцы') return fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32');
  }
  if (mainPipeDiameter === 88.9) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2'].includes(fittingId);
    if (category === 'Муфты') return ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4'].includes(fittingId);
    if (category === 'Фланцы') return fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40');
  }
  if (mainPipeDiameter === 101.6) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2'].includes(fittingId);
    if (category === 'Фланцы') return fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40');
  }
  if (mainPipeDiameter === 114.3) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2'].includes(fittingId);
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 129) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2'].includes(fittingId);
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 139.7) {
    if (category === 'Ниппели') return ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2'].includes(fittingId);
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 159) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 168.3) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 219.1) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80', 'Flanec_100'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 273) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80', 'Flanec_100', 'Flanec_125'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 323.9) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80', 'Flanec_100', 'Flanec_125', 'Flanec_150'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 355.6) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80', 'Flanec_100', 'Flanec_125', 'Flanec_150'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 406.4) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80', 'Flanec_100', 'Flanec_125', 'Flanec_150', 'Flanec_200'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 508) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80', 'Flanec_100', 'Flanec_125', 'Flanec_150', 'Flanec_200', 'Flanec_250'].some(p => fittingId.startsWith(p));
  }
  if (mainPipeDiameter === 609.6) {
    if (category === 'Фланцы') return ['Flanec_25_', 'Flanec_32', 'Flanec_40', 'Flanec_50', 'Flanec_65', 'Flanec_80', 'Flanec_100', 'Flanec_125', 'Flanec_150', 'Flanec_200', 'Flanec_250', 'Flanec_300'].some(p => fittingId.startsWith(p));
  }
  return true;
};

/**
 * Торцевые подключения распределительного коллектора — квадратный профиль гребёнки.
 * (Логика совпадает с бывшей локальной функцией в DistributionCollectorEditor.)
 */
export const isDistributionEndFittingCompatibleWithSquareProfile = (fittingId, profile) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;

  const category = fittingData.category;

  if (profile === '40x40') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2'];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      return false;
    }
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1'];
      return allowedNakGaikas.includes(fittingId);
    }
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1'];
      return allowedShaibas.includes(fittingId);
    }
  }

  if (profile === '50x50') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4'];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      return false;
    }
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1', 'Nak_Gaika_1_1.4', 'Nak_Gaika_1_1.2'];
      return allowedNakGaikas.includes(fittingId);
    }
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1', 'Shaib_Nar_Rezba_1_1.4', 'Shaib_Nar_Rezba_1_1.2'];
      return allowedShaibas.includes(fittingId);
    }
  }

  if (profile === '60x60') {
    if (category === 'Ниппели') {
      const allowedNippels = [
        'Nippel_1.4',
        'Nippel_3.8',
        'Nippel_1.2',
        'Nippel_3.4',
        'Nippel_1',
        'Nippel_1_1.4',
        'Nippel_1_1.2',
      ];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = [
        'Mufta_1.4',
        'Mufta_3.8',
        'Mufta_1.2',
        'Mufta_3.4',
        'Mufta_1',
        'Mufta_1_1.4',
      ];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      if (
        fittingId.startsWith('Flanec_25_') ||
        fittingId.startsWith('Flanec_32') ||
        fittingId.startsWith('Flanec_40')
      ) {
        return true;
      }
      return false;
    }
    if (category === 'Накидные гайки') {
      return true;
    }
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  if (profile === '80x80') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = [
        'Mufta_1.4',
        'Mufta_3.8',
        'Mufta_1.2',
        'Mufta_3.4',
        'Mufta_1',
        'Mufta_1_1.4',
        'Mufta_1_1.2',
        'Mufta_2',
      ];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50')) {
        return true;
      }
      return false;
    }
    if (category === 'Накидные гайки') {
      return true;
    }
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  if (profile === '100x100') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      return true;
    }
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65')) {
        return true;
      }
      return false;
    }
    if (category === 'Накидные гайки') {
      return true;
    }
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  if (profile === '150x150') {
    if (category === 'Ниппели') {
      return true;
    }
    if (category === 'Муфты') {
      return true;
    }
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100')) {
        return true;
      }
      return false;
    }
    if (category === 'Накидные гайки') {
      return true;
    }
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  return true;
};

/**
 * Контуры распределительного коллектора — квадратный профиль гребёнки.
 * (Бывшая локальная функция DistributionCollectorEditor.)
 */
export const isDistributionCircuitFittingCompatibleWithSquareProfile = (fittingId, profile) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;

  const category = fittingData.category;

  if (profile === '40x40') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8'];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      return false;
    }
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1'];
      return allowedNakGaikas.includes(fittingId);
    }
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1'];
      return allowedShaibas.includes(fittingId);
    }
  }

  if (profile === '50x50') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2'];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      return false;
    }
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1'];
      return allowedNakGaikas.includes(fittingId);
    }
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1'];
      return allowedShaibas.includes(fittingId);
    }
  }

  if (profile === '60x60') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4'];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      return fittingId.startsWith('Flanec_25_');
    }
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1', 'Nak_Gaika_1_1.4', 'Nak_Gaika_1_1.2'];
      return allowedNakGaikas.includes(fittingId);
    }
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1', 'Shaib_Nar_Rezba_1_1.4', 'Shaib_Nar_Rezba_1_1.2'];
      return allowedShaibas.includes(fittingId);
    }
  }

  if (profile === '80x80') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4'];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40')) {
        return true;
      }
      return false;
    }
    if (category === 'Накидные гайки') {
      return true;
    }
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  if (profile === '100x100') {
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2'];
      return allowedNippels.includes(fittingId);
    }
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4', 'Mufta_1_1.2'];
      return allowedMuftas.includes(fittingId);
    }
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50')) {
        return true;
      }
      return false;
    }
    if (category === 'Накидные гайки') {
      return true;
    }
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  if (profile === '150x150') {
    if (category === 'Ниппели') {
      return true;
    }
    if (category === 'Муфты') {
      return true;
    }
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80')) {
        return true;
      }
      return false;
    }
    if (category === 'Накидные гайки') {
      return true;
    }
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  return true;
};

// ============================================================================
// ФУНКЦИИ ДЛЯ ФОРМАТИРОВАНИЯ
// ============================================================================

/**
 * Маппинг диаметров труб на диаметры отверстий для сварки
 * Отверстия делаются немного меньше для оставления стенки под сварку
 */
export const PIPE_TO_HOLE_DIAMETER = {
  13.7: 13.5,
  17.2: 17,
  21.3: 21,
  26.9: 26.6,
  32: 31.7,
  33.7: 33.5,
  42.4: 42.3,
  48.3: 48.1,
  60.3: 59.8,
  76.1: 75.8,
  88.9: 88.5,
  114.3: 114,
  139.7: 139.5,
  168.3: 168,
  219.1: 218.8,
  273: 272.7,     // DN250
  323.9: 323.6,   // DN300
  355.6: 355.3,   // DN350
  406.4: 406.1,   // DN400
  508: 507.7,     // DN500 (альтернативный размер)
  609.6: 609.3,   // DN500 (основной)
};

/**
 * Диаметры муфт (не уменьшаются для сварки, кроме особых случаев)
 */
export const MUFTA_DIAMETERS = {
  17.4: 17.4,   // Муфта 1/4"
  20.8: 20.8,   // Муфта 3/8"
  24.5: 24.5,   // Муфта 1/2" - особая логика (24.5 для круглых, 21 для квадратных/листа)
  29.9: 29.9,   // Муфта 3/4"
  38: 38,       // Муфта 1"
  48: 48,       // Муфта 1 1/4"
  53.9: 53.9,   // Муфта 1 1/2"
  66: 66,       // Муфта 2"
};

/**
 * Преобразует диаметр трубы в диаметр отверстия для сварки
 * @param {number} pipeDiameter - диаметр трубы (мм)
 * @param {Object} options - опции
 * @param {boolean} options.isSquare - труба квадратная/лист (для муфты 1/2")
 * @param {boolean} options.isThroughHole - сквозное отверстие (длинный контур или сквозной выход)
 * @param {string} options.squareProfile - профиль квадратной трубы (например, '80x80') для отверстий под коллекторы в гидроразделителе
 * @returns {number|string} - диаметр отверстия (мм) или размер квадратного отверстия ('70x70')
 */
export const getHoleDiameterForPipe = (pipeDiameter, options = {}) => {
  if (!pipeDiameter) return 20; // По умолчанию
  
  const { isSquare = false, isThroughHole = false, squareProfile = null } = options;
  
  // Если передан квадратный профиль (для отверстий под коллекторы в гидроразделителе)
  // Уменьшаем размер на 10мм с каждой стороны
  if (squareProfile) {
    const sizes = squareProfile.split('x').map(s => parseInt(s));
    if (sizes.length === 2) {
      const reducedSize1 = sizes[0] - 10;
      const reducedSize2 = sizes[1] - 10;
      return `${reducedSize1}x${reducedSize2}`;
    }
    // Если не удалось распарсить, возвращаем оригинал
    return squareProfile;
  }
  
  // Проверяем, это муфта?
  if (MUFTA_DIAMETERS[pipeDiameter]) {
    // Особая логика для муфты 1/2" (24.5)
    if (pipeDiameter === 24.5) {
      // Для сквозных отверстий (длинные контуры, сквозные выходы) - всегда оригинальный размер
      if (isThroughHole) {
        return 24.5;
      }
      // Для обычных отверстий на квадратных - 21мм, на круглых - 24.5мм
      return isSquare ? 21 : 24.5;
    }
    // Для остальных муфт - оригинальный размер
    return MUFTA_DIAMETERS[pipeDiameter];
  }
  
  // Точное совпадение для труб
  if (PIPE_TO_HOLE_DIAMETER[pipeDiameter]) {
    return PIPE_TO_HOLE_DIAMETER[pipeDiameter];
  }
  
  // Ищем ближайшее значение (с округлением до 0.1)
  const rounded = Math.round(pipeDiameter * 10) / 10;
  if (PIPE_TO_HOLE_DIAMETER[rounded]) {
    return PIPE_TO_HOLE_DIAMETER[rounded];
  }
  
  // Проверяем все ключи таблицы с допуском 0.01 мм
  for (const [key, value] of Object.entries(PIPE_TO_HOLE_DIAMETER)) {
    const keyNum = parseFloat(key);
    if (Math.abs(keyNum - pipeDiameter) < 0.01) {
      return value;
    }
  }
  
  // Если размера нет в таблице: до 30 мм минус 0.2, дальше минус 0.3
  if (pipeDiameter < 30) {
    return Math.round((pipeDiameter - 0.2) * 10) / 10;
  }
  return Math.round((pipeDiameter - 0.3) * 10) / 10;
};

/**
 * Форматирует размер для отображения
 * @param {number} value - значение
 * @param {number} precision - точность (количество знаков после запятой)
 * @returns {string} - отформатированное значение
 */
export const formatDimension = (value, precision = 0) => {
  if (precision === 0) {
    return Math.round(value).toString();
  }
  return value.toFixed(precision);
};

// ============================================================================
// ФУНКЦИИ ДЛЯ ОПРЕДЕЛЕНИЯ ЗАГЛУШЕК/ПЕРЕХОДОВ
// ============================================================================

/**
 * Нужен ли на торце переход или заглушка перед фитингом.
 *
 * Впритык (needsCap: false, fitsFlush: true) — без заглушки и без перехода, в т.ч.:
 * ниппель, если ⌀ ряда = ⌀ гребёнки; муфты Mufta_1 и Mufta_1_1.4 при ⌀42.4;
 * Mufta_1_1.4 и Mufta_1_1.2 при ⌀48.3; Mufta_2 при ⌀60.3 (см. блок «Случаи впритык» ниже).
 * Исключение: ниппель 1¼″ (⌀42.4) на гребёнке ⌀48.3 — переход 48.3→42.4, не впритык.
 *
 * @param {string} fittingId - ID фитинга
 * @param {number} mainPipeDiameter - наружный ⌀ гребёнки, мм
 * @returns {{ needsCap: boolean, capType?: string, reducer?: object, fitsFlush?: boolean, pipeDiameter?: number }}
 */
export const getCapRequirementForFitting = (fittingId, mainPipeDiameter) => {
  if (!fittingId) return { needsCap: false };
  
  const isFlange = fittingId.startsWith('Flanec_');
  const isNippel = fittingId.startsWith('Nippel_');
  const isMufta = fittingId.startsWith('Mufta_');
  const isNakGaika = fittingId.startsWith('Nak_Gaika_');
  const isShaibaNarRezba = fittingId.startsWith('Shaib_Nar_Rezba_');
  
  // Для ниппелей: проверяем нужен ли переход
  if (isNippel) {
    const nippelDiameter = fittingsData[fittingId]?.diameter;
    
    // Специальные случаи с переходами
    if (mainPipeDiameter === 48.3 && fittingId === 'Nippel_1_1.4') {
      const reducer = findConcentricReducer(48.3, 42.4);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    if (mainPipeDiameter === 60.3 && fittingId === 'Nippel_1_1.2') {
      const reducer = findConcentricReducer(60.3, 48.3);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    if (mainPipeDiameter === 76.1 && fittingId === 'Nippel_2') {
      const reducer = findConcentricReducer(76.1, 60.3);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    if (mainPipeDiameter === 88.9 && fittingId === 'Nippel_2_1/2') {
      const reducer = findConcentricReducer(88.9, 76.1);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    // Переход 114.3х88.9 в автоконструкторе не предлагается: findConcentricReducer вернёт null,
    // ниже включится эллиптическая заглушка.
    if (mainPipeDiameter === 114.3 && fittingId === 'Nippel_3') {
      const reducer = findConcentricReducer(114.3, 88.9);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    
    // Общий случай
    if (nippelDiameter && nippelDiameter !== mainPipeDiameter) {
      return { needsCap: true, capType: 'elliptical' };
    }
    return { needsCap: false, fitsFlush: true };
  }
  
  // Для муфт: специальная логика
  if (isMufta) {
    // Специальные случаи с переходами (проверяем ПЕРВЫМИ!)
    if (mainPipeDiameter === 48.3 && fittingId === 'Mufta_1') {
      const reducer = findConcentricReducer(48.3, 42.4);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    if (mainPipeDiameter === 60.3 && fittingId === 'Mufta_1_1.4') {
      const reducer = findConcentricReducer(60.3, 48.3);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    if (mainPipeDiameter === 60.3 && fittingId === 'Mufta_1_1.2') {
      const reducer = findConcentricReducer(60.3, 48.3);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    if (mainPipeDiameter === 76.1 && fittingId === 'Mufta_1_1.2') {
      const reducer = findConcentricReducer(76.1, 60.3);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    if (mainPipeDiameter === 76.1 && fittingId === 'Mufta_2') {
      const reducer = findConcentricReducer(76.1, 60.3);
      if (reducer) return { needsCap: true, capType: 'reducer', reducer: reducer };
    }
    
    // Случаи впритык (проверяем ПОСЛЕ переходов!)
    if (mainPipeDiameter === 42.4 && (fittingId === 'Mufta_1' || fittingId === 'Mufta_1_1.4')) {
      return { needsCap: false, fitsFlush: true };
    }
    if (mainPipeDiameter === 48.3 && (fittingId === 'Mufta_1_1.4' || fittingId === 'Mufta_1_1.2')) {
      return { needsCap: false, fitsFlush: true };
    }
    if (mainPipeDiameter === 60.3 && fittingId === 'Mufta_2') {
      return { needsCap: false, fitsFlush: true };
    }
    
    return { needsCap: true, capType: 'elliptical' };
  }
  
  // Для фланцев
  if (isFlange) {
    const dn = extractDnFromFlangeKey(fittingId);
    const flangePipeDiameter = getPipeDiameterForDn(dn);
    
    if (flangePipeDiameter && flangePipeDiameter !== mainPipeDiameter && mainPipeDiameter > flangePipeDiameter) {
      const reducer = findConcentricReducer(mainPipeDiameter, flangePipeDiameter);
      if (reducer) {
        return { needsCap: true, capType: 'reducer', reducer: reducer, pipeDiameter: flangePipeDiameter };
      }
      return { needsCap: true, capType: 'elliptical', pipeDiameter: flangePipeDiameter };
    }
    return { needsCap: false, fitsFlush: true, pipeDiameter: flangePipeDiameter };
  }
  
  // Для накидных гаек и шайб
  if (isNakGaika || isShaibaNarRezba) {
    let pipeDiameter;
    if (isNakGaika) {
      const size = extractSizeFromNakGaikaKey(fittingId);
      pipeDiameter = getPipeDiameterForNakGaika(size);
    } else {
      const size = extractSizeFromShaibaNarRezba(fittingId);
      pipeDiameter = getPipeDiameterForShaibaNarRezba(size);
    }
    
    if (pipeDiameter && pipeDiameter !== mainPipeDiameter) {
      return { needsCap: true, capType: 'elliptical', pipeDiameter: pipeDiameter };
    }
    return { needsCap: false, fitsFlush: true, pipeDiameter: pipeDiameter };
  }
  
  return { needsCap: false };
};

/**
 * Фиксированные изменённые значения для ниппелей на круглых трубах
 * (зависит от наружного диаметра трубы и размера ниппеля).
 */
const NIPPEL_PIPE_OVERRIDE_RULES = [
  [88.9, 'Nippel_2', 40],
  [101.6, 'Nippel_2', 40],
  [114.3, 'Nippel_2_1/2', 40],
  [129, 'Nippel_3', 45],
  [139.7, 'Nippel_3', 45],
  [159, 'Nippel_3', 50],
  [159, 'Nippel_4', 45],
  [168.3, 'Nippel_4', 50],
  [219.1, 'Nippel_4', 55],
];

/**
 * Возвращает фиксированное изменённое значение для ниппеля на конкретной трубе.
 * @param {string} fittingId - ID ниппеля (Nippel_*)
 * @param {number} pipeDiameter - наружный диаметр трубы
 * @returns {number|null} - значение в мм или null, если правило не задано
 */
export const getNippelOverrideByPipe = (fittingId, pipeDiameter) => {
  if (!fittingId?.startsWith('Nippel_') || pipeDiameter == null) return null;

  const d = Number(pipeDiameter);
  const exact = NIPPEL_PIPE_OVERRIDE_RULES.find(
    ([pipeD, id]) => d === pipeD && id === fittingId
  );
  if (exact) return exact[2];

  if (d >= 273 && fittingId === 'Nippel_4') return 60;

  return null;
};

/**
 * Изменённое значение для ниппеля на круглой трубе:
 * сначала проверяет правила по диаметру трубы, иначе — стандартная формула (−8/−10 мм).
 * @param {string} fittingId
 * @param {number} pipeDiameter
 * @param {number} catalogLength - каталожная длина ниппеля
 * @returns {number}
 */
export const getNippelRoundOverrideValue = (fittingId, pipeDiameter, catalogLength) => {
  const pipeOverride = getNippelOverrideByPipe(fittingId, pipeDiameter);
  if (pipeOverride != null) return pipeOverride;
  if (fittingId === 'Nippel_1') return catalogLength - 8;
  return catalogLength - 10;
};

// Муфту на торце в производстве режут пополам. Это наружная длина: в трубу торец не входит.
export const END_MUFTA_CUT_LENGTH = {
  'Mufta_3.4': 17,
  'Mufta_1': 21,
  'Mufta_1_1.4': 23,
  'Mufta_1_1.2': 23,
  'Mufta_1_1.5': 23,
  'Mufta_2': 27,
};

export const getEndMuftaCutLength = (fittingId) => END_MUFTA_CUT_LENGTH[fittingId] ?? null;

/** Пустое поле — авто. У муфты на торце авто равно длине после резки, у остальных — каталог. */
export const endFittingAutoLength = (fittingId, userLength, catalogLength) => {
  const n = Number(userLength);
  if (userLength != null && userLength !== '' && Number.isFinite(n) && n > 0) return n;
  return getEndMuftaCutLength(fittingId) ?? catalogLength;
};

/** Торцевой фитинг: слева/справа коллектора или сверху/снизу разделителя. Контуры снизу не входят. */
export const isEndConnectionFitting = (fit) => {
  const id = String(fit?.id || '');
  if (id.includes('-conn-')) return true;
  if (id.startsWith('fitting-bottom-circuit-')) return false;
  if (id.startsWith('fitting-top-') || id.startsWith('fitting-bottom-')) return true;
  const parts = id.split('-');
  if (parts[0] === 'fitting' && (parts[1] === 'left' || parts[1] === 'right') && parts.length === 3) {
    const stamp = Number(parts[2]);
    return stamp > 10000000000;
  }
  return false;
};

/**
 * Изменённое значение муфты на квадратном контуре / боковом подключении: каталог − 3 мм.
 * Mufta_1.2 — без override.
 */
export const getSquareMuftaCircuitDisplayValue = (fittingId, catalogLength) => {
  if (!fittingId?.startsWith('Mufta_')) return null;
  if (fittingId === 'Mufta_1.2') return null;
  return catalogLength - 3;
};

/**
 * Изменённое значение муфты на торцевом подключении (квадратный профиль).
 */
export const getSquareMuftaEndConnectionDisplayValue = (fittingId) =>
  getEndMuftaCutLength(fittingId);

export const isNippelOrMufta = (fittingId) =>
  fittingId?.startsWith('Nippel_') || fittingId?.startsWith('Mufta_');

/** Вылет, который пользователь вписал у лицевого или дополнительного выхода. */
export const facingStickFields = (source) => {
  const id = source?.fittingId || source?.key || '';
  const special = /^(Flanec_|Nak_Gaika_|Shaib_Nar_Rezba_)/.test(id);
  const raw = special
    ? (source?.flangePipeLength ?? source?.fittingLength)
    : source?.fittingLength;
  const value = raw === '' || raw == null ? null : Number(raw);
  if (!Number.isFinite(value) || value <= 0) return {};
  if (special) return { flangePipeLength: value };
  return { fittingLength: value };
};

/**
 * Труба патрубка как у контура: накидная и шайба — x3 и покрытие из каталога,
 * фланец — матовая толщина не больше стенки основной трубы.
 */
function circuitStubPipeSpec(kind, pipeOd, parent) {
  if (kind === 'nak' || kind === 'shaiba') {
    return { thickness: 'x3', coating: getActualCoating(pipeOd, 'x3', 'Матовый') };
  }
  const mainThickness = parent?.pipeSpec?.thickness;
  const mainDiameter = Number(parent?.pipeSpec?.diameter) || 0;
  if (mainThickness) {
    const mainNum = parseFloat(String(mainThickness).replace(/x/i, ''));
    const available = getAvailableThicknesses(pipeOd, 'Матовый');
    const valid = available.filter((item) => parseFloat(String(item).replace(/x/i, '')) <= mainNum);
    const thickness = valid.length > 0 ? valid[valid.length - 1] : (available[0] || 'x2');
    return { thickness, coating: 'Матовый' };
  }
  return { thickness: determineThickness(mainDiameter, pipeOd), coating: 'Матовый' };
}

/**
 * Длина ниппеля или муфты в комплектующих: видимый вылет плюс заход в трубу,
 * как у контура. Для лицевых и термометров высота на чертеже — размер DXF, не эта длина.
 */
export const pricedNippelMuftaLength = (fitting, cylinders) => {
  const key = fitting?.itemKey || fitting?.key || '';
  const info = fittingsData[key];
  const catalog = Number(info?.length) || 0;
  if (!isNippelOrMufta(key) || catalog <= 0) return null;
  const parent = (cylinders || []).find((cyl) => cyl.id === fitting.igesParentCylinderId);
  const shape = parent?.pipeSpec?.shape === 'square' ? 'square' : 'round';
  const cross = parent ? Math.min(Number(parent.width) || 0, Number(parent.height) || 0) : 0;
  const pipeDiameter = Number(parent?.pipeSpec?.diameter) || cross;
  const height = Number(fitting.height) || 0;
  const typed = Number(fitting.fittingLength);
  const override = fitting.overrideEnabled
    ? Number(String(fitting.overrideText ?? '').replace(',', '.'))
    : NaN;
  // Торец в трубу не входит. Старая подпись короче тела — это уже готовая длина (у муфты после резки).
  if (isEndConnectionFitting(fitting)) {
    if (Number.isFinite(override) && override > 0 && (height <= 0 || height > override + 0.2)) {
      return Math.round(override * 100) / 100;
    }
    if (height > 0) return Math.round(height * 100) / 100;
    const cut = getEndMuftaCutLength(key);
    if (cut != null) return cut;
    return catalog;
  }
  let visible = null;
  if (fitting.isSelfFacing) {
    // Высота лицевого вида — размер картинки, не вылет.
    if (Number.isFinite(typed) && typed > 0) visible = typed;
    else if (Number.isFinite(override) && override > 0) visible = override;
  } else if (Number.isFinite(override) && override > 0 && height > override + 0.2) {
    // Старый чертёж: тело нарисовано каталогом, подпись короче.
    visible = override;
  } else if (height > 0) {
    visible = height;
  }
  if (visible == null) {
    if (key.startsWith('Nippel_')) visible = getNippelAutoDisplayValue(key, pipeDiameter, catalog, shape);
    else visible = getMuftaAutoDisplayValue(key, catalog, shape);
  }
  if (visible == null) return catalog;
  const offset = getNippelMuftaInsertionOffset(key, pipeDiameter, catalog, shape);
  return Math.round((Number(visible) + Math.max(0, offset)) * 100) / 100;
};

/**
 * Патрубок и бортшайба лицевого выхода. На чертеже их нет: виден только торец,
 * а в стоимости и в STEP они есть.
 */
export const facingOutletBomParts = (fitting, cylinders) => {
  if (!fitting?.isSelfFacing || fitting.isHidden) return [];
  const key = fitting.itemKey || fitting.key || '';
  const parent = (cylinders || []).find((cyl) => cyl.id === fitting.igesParentCylinderId);
  const square = parent?.pipeSpec?.shape === 'square';
  const cross = parent ? Math.min(Number(parent.width) || 0, Number(parent.height) || 0) : 0;
  const mainDiameter = Number(parent?.pipeSpec?.diameter) || cross;
  const typed = Number(fitting.flangePipeLength ?? fitting.fittingLength);
  const user = Number.isFinite(typed) && typed > 0 ? typed : null;
  const parts = [];
  const addPipe = (diameter, length, kind) => {
    if (!diameter || length < 0.5) return;
    const spec = circuitStubPipeSpec(kind, diameter, parent);
    parts.push({
      isPipe: true,
      diameter,
      thickness: spec.thickness,
      coating: spec.coating,
      length: Math.round(length * 100) / 100,
    });
  };

  if (key.startsWith('Flanec_')) {
    const dn = (key.match(/Flanec_(\d+)/) || [])[1];
    const pipeOd = DN_TO_PIPE_DIAMETER[dn];
    if (!pipeOd) return parts;
    const free = !key.endsWith('_welded');
    const collar = free ? fittingsData[`Bortshaiba_${dn}`] : null;
    const collarLen = collar?.length || 0;
    const visible = user ?? 100;
    const insertion = flangePipeInsertion(mainDiameter, pipeOd, square ? 'square' : 'round');
    if (collar) parts.push({ itemKey: `Bortshaiba_${dn}` });
    addPipe(pipeOd, Math.max(0, visible - collarLen) + insertion, 'flange');
    return parts;
  }

  if (key.startsWith('Nak_Gaika_')) {
    const pipeOd = NAK_GAIKA_TO_PIPE_DIAMETER[key.slice('Nak_Gaika_'.length)];
    const washerKey = getShaibaKeyForFitting(key);
    const washer = fittingsData[washerKey];
    if (!pipeOd || !washer) return parts;
    const measure = nakShaibaPipeMeasure(user, washer.length, square ? 'square' : 'round', false);
    parts.push({ itemKey: washerKey });
    addPipe(pipeOd, measure.outside + measure.insertion, 'nak');
    return parts;
  }

  if (key.startsWith('Shaib_Nar_Rezba_')) {
    const pipeOd = SHAIBA_NAR_REZBA_TO_PIPE_DIAMETER[key.slice('Shaib_Nar_Rezba_'.length)];
    const washer = fittingsData[key];
    if (!pipeOd || !washer) return parts;
    const measure = nakShaibaPipeMeasure(user, washer.length, square ? 'square' : 'round', true);
    addPipe(pipeOd, measure.outside + measure.insertion, 'shaiba');
    return parts;
  }

  return parts;
};

/**
 * Производственная длина ниппеля в режиме «Авто» (f.height).
 */
export const getNippelAutoProductionLength = (_fittingId, _shape, catalogLength) => catalogLength;

/**
 * Видимый вылет ниппеля в режиме «Авто» (overrideText).
 */
export const getNippelAutoDisplayValue = (fittingId, pipeDiameter, catalogLength, shape) => {
  if (shape === 'square') {
    return catalogLength - 3;
  }
  return getNippelRoundOverrideValue(fittingId, pipeDiameter, catalogLength);
};

/**
 * Видимый вылет муфты в режиме «Авто» (overrideText).
 */
export const getMuftaAutoDisplayValue = (fittingId, catalogLength, shape) => {
  if (shape === 'square') {
    return getSquareMuftaCircuitDisplayValue(fittingId, catalogLength);
  }
  if (fittingId === 'Mufta_1.2' || fittingId === 'Mufta_3.8' || fittingId === 'Mufta_1.4') {
    return catalogLength - 5;
  }
  if (fittingId?.startsWith('Mufta_')) {
    return catalogLength - 10;
  }
  return null;
};

/**
 * Разница между производственной и видимой длиной (заход в трубу).
 */
export const getNippelMuftaInsertionOffset = (fittingId, pipeDiameter, catalogLength, shape) => {
  if (fittingId?.startsWith('Nippel_')) {
    const production = getNippelAutoProductionLength(fittingId, shape, catalogLength);
    const display = getNippelAutoDisplayValue(fittingId, pipeDiameter, catalogLength, shape);
    return production - display;
  }
  if (fittingId?.startsWith('Mufta_')) {
    const display = getMuftaAutoDisplayValue(fittingId, catalogLength, shape);
    if (display == null) return 0;
    return catalogLength - display;
  }
  return 0;
}

/** Труба фланца → ниппель того же наружного диаметра. */
const FLANGE_PIPE_TO_NIPPEL = [
  [21.3, 'Nippel_1.2'],
  [26.9, 'Nippel_3.4'],
  [33.7, 'Nippel_1'],
  [42.4, 'Nippel_1_1.4'],
  [48.3, 'Nippel_1_1.2'],
  [60.3, 'Nippel_2'],
  [76.1, 'Nippel_2_1/2'],
  [88.9, 'Nippel_3'],
  [114.3, 'Nippel_4'],
];

/**
 * Заход патрубка фланца в тело.
 * На квадрате всегда 3 мм. На круглой трубе табличный заход больше 20 мм оставляем,
 * 20 мм и меньше заменяем заходом ниппеля с той же трубой.
 */
export const flangePipeInsertion = (mainDiameter, pipeOd, shape) => {
  if (shape === 'square') return 3;
  const table = getInsertionDepth(mainDiameter, pipeOd) || 0;
  if (table > 20) return table;
  const pair = FLANGE_PIPE_TO_NIPPEL.find(([diameter]) => Math.abs(diameter - Number(pipeOd)) < 0.05);
  if (!pair) return table;
  const catalog = Number(fittingsData[pair[1]]?.length) || 0;
  const offset = getNippelMuftaInsertionOffset(pair[1], mainDiameter, catalog, 'round');
  return offset > 0 ? offset : table;
};

/**
 * Вылет накидной гайки и шайбы с резьбой — от наружной стенки до торца шайбы.
 * Пустое поле и старые авто-значения 40/58 — это видимые 32 мм (круг) и 54 мм (квадрат).
 * outside — труба снаружи стенки, до начала шайбы.
 * insertion — заход в тело (10 мм круг, 3 мм квадрат); у шайбы с резьбой сюда же 3 мм захода в шайбу.
 */
export const nakShaibaPipeMeasure = (rawLength, washerLength, shape, intoWasher, lengthIsVisible = false) => {
  const square = shape === 'square';
  const auto = square ? 58 : 40;
  const shown = square ? 54 : 32;
  const raw = Number(rawLength);
  // lengthIsVisible — длина уже в видимом вылете (длинный патрубок пары, сквозной выход).
  // Иначе 40/58 — старые авто-значения, их показываем как 32/54.
  const explicit = Number.isFinite(raw) && raw > 0 && (lengthIsVisible || raw !== auto);
  const visible = explicit ? raw : shown;
  const washer = Number(washerLength) || 0;
  const outside = Math.max(0, visible - washer);
  const insertion = (square ? 3 : 10) + (intoWasher ? 3 : 0);
  return { visible, outside, insertion };
};

/**
 * Видимый вылет короткого патрубка фланца, накидной гайки или шайбы с резьбой.
 * Пустое поле гайки/шайбы — 32 мм на круглой трубе и 54 мм на квадрате.
 */
export const visibleSpecialStubLength = (fittingId, rawLength, shape) => {
  if (fittingId?.startsWith('Flanec_')) {
    const raw = Number(rawLength);
    return Number.isFinite(raw) && raw > 0 ? raw : 100;
  }
  if (fittingId?.startsWith('Nak_Gaika_') || fittingId?.startsWith('Shaib_Nar_Rezba_')) {
    return nakShaibaPipeMeasure(
      rawLength,
      0,
      shape,
      fittingId.startsWith('Shaib_Nar_Rezba_'),
    ).visible;
  }
  return null;
};

/**
 * Override для ниппеля/муфты в режиме «Авто».
 */
export const getAutoNippelMuftaDimensionOverride = (fittingId, pipeDiameter, catalogLength, shape) => {
  let customValue = null;
  if (fittingId?.startsWith('Nippel_')) {
    customValue = getNippelAutoDisplayValue(fittingId, pipeDiameter, catalogLength, shape);
  } else if (fittingId?.startsWith('Mufta_')) {
    customValue = getMuftaAutoDisplayValue(fittingId, catalogLength, shape);
  }
  if (customValue == null) return {};
  return { overrideEnabled: true, overrideText: String(customValue) };
};

/**
 * Ручной вылет: на чертеже видна введённая длина, заход живёт отдельно.
 */
export const resolveManualNippelMuftaFitting = ({
  fittingId,
  visibleLength,
  pipeDiameter,
  catalogLength,
  shape,
}) => {
  const visible = Number(visibleLength);
  const offset = getNippelMuftaInsertionOffset(fittingId, pipeDiameter, catalogLength, shape);
  return {
    length: visible,
    insertion: Math.max(0, offset),
    dimensionOverride: {},
  };
};

/**
 * Универсальный расчёт длины и override для ниппеля/муфты.
 * @returns {{ length: number, dimensionOverride: object } | null}
 */
export const resolveNippelMuftaFitting = ({
  fittingId,
  fittingLength,
  pipeDiameter,
  catalogLength,
  shape,
  fittingLengthIsProduction = false,
}) => {
  if (!isNippelOrMufta(fittingId)) return null;

  const offset = Math.max(0, getNippelMuftaInsertionOffset(fittingId, pipeDiameter, catalogLength, shape));

  if (fittingLength !== null && fittingLength !== undefined) {
    if (fittingLengthIsProduction) {
      const production = Number(fittingLength);
      return {
        length: production - offset,
        insertion: offset,
        dimensionOverride: {},
      };
    }
    return resolveManualNippelMuftaFitting({
      fittingId,
      visibleLength: fittingLength,
      pipeDiameter,
      catalogLength,
      shape,
    });
  }

  const visible = fittingId?.startsWith('Nippel_')
    ? getNippelAutoDisplayValue(fittingId, pipeDiameter, catalogLength, shape)
    : getMuftaAutoDisplayValue(fittingId, catalogLength, shape);
  if (visible == null) {
    return { length: catalogLength, insertion: 0, dimensionOverride: {} };
  }
  return { length: visible, insertion: offset, dimensionOverride: {} };
};

/**
 * Override для накидных гаек / шайб на боковых подключениях гидроразделителя.
 */
export const getNakGaikaShaibaSideConnectionOverride = () => ({});

/**
 * Геометрическая длина вылета и override для размерной линии
 * бокового подключения гидроразделителя.
 */
export const resolveSideConnectionOutletDimension = ({
  fittingId,
  connFittingLength,
  pipeDiameter,
  catalogLength,
  shape,
  fallbackLength,
}) => {
  const nippelMufta = resolveNippelMuftaFitting({
    fittingId,
    fittingLength: connFittingLength ?? null,
    pipeDiameter,
    catalogLength,
    shape,
  });

  if (nippelMufta) {
    return {
      geometricLength: nippelMufta.length,
      dimensionOverride: {},
    };
  }

  const visible = visibleSpecialStubLength(fittingId, connFittingLength, shape);
  if (visible != null) {
    return { geometricLength: visible, dimensionOverride: {} };
  }

  return {
    geometricLength: fallbackLength,
    dimensionOverride: {},
  };
};

